import React from 'react'
import { FC, useState } from "react";
import { DataGrid, DataGridProps, GridRowHeightReturnValue } from "@mui/x-data-grid";
import { useStyles } from "./styles";

interface GridProps {
  columns: any[];
  rows: any[];
  getRowId: (param: any) => string;
  loading?: boolean;
  pageSize?: number;
  onPageSizeChange?: (pageSize: number) => void;
  className?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
  onPageChange?: (params: any) => void;
  getRowHeight?: (params: any) => GridRowHeightReturnValue;
  experimentalFeatures?: any;
  columnGroupingModel?: any;
  gridRef?: any;
  disableVirtualization?: boolean;
}

export const CustomDataGrid: FC<GridProps> = (props) => {
  const styles = useStyles();
  const [pageSize, setPageSize] = useState<number>(50);

  const defaultDataGridOptions: DataGridProps = {
    columns: [],
    rows: [],
    className: styles.tableWrapper,
    pageSize: pageSize,
    rowsPerPageOptions: [20, 30, 40, 50],
    disableColumnFilter: true,
    disableColumnMenu: true,
    disableColumnSelector: true,
    disableSelectionOnClick: true,
    autoHeight: true,
    onPageSizeChange: setPageSize,
    componentsProps: {
      footer: {
        className: styles.smallFooter,
      }
    },
    ...(props.hideHeader && { headerHeight: 0 }),
    disableVirtualization: process.env.NODE_ENV === "test", // Needed for rendering all columns in test env.
  };

  return <DataGrid ref={props?.gridRef} style={{ fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif" }} {...defaultDataGridOptions} {...props} />;
};
